// AppContext.js
import React, { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [selectedData, setSelectedData] = useState(null);

  return (
    <AppContext.Provider value={{ selectedData, setSelectedData }}>
      {children}
    </AppContext.Provider>
  );
};
